module.exports = __webpack_public_path__ + "static/Group5998@2x-866016dcf19f2a80dbecdbe6bd999396.png";